import React, { ReactElement } from 'react';
import Card from 'components/atoms/Card/Card';
import Txt from 'components/atoms/Txt/Txt';

import clsx from 'clsx';
import classes from './ReferralCard.module.scss';

export interface ReferralCardProps {
  title: string;
  value: number | string | ReactElement;
  icon?: React.ReactNode;
  className?: string;
}

const ReferralCard: React.FC<ReferralCardProps> = ({ title, value, icon, className }) => (
  <Card className={clsx(classes.root, className)}>
    <Txt className={classes.title}>{title}</Txt>
    <div className={classes.iconCountRow}>
      {icon && <span className={classes.icon}>{icon}</span>}
      <span className={classes.count}>{value}</span>
    </div>
  </Card>
);

export default ReferralCard;
